module.exports = __webpack_public_path__ + "static/media/powered_by (WHITE).aedbbe5e.png";